module.exports = "<div style=\"position: fixed; top: 0; right: 0;\">\r\n    <button (click)=\"zoomIn()\">+</button>\r\n    <button (click)=\"zoomOut()\">-</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/scaling/scaling.component.html
// module id = ./src/app/components/scaling/scaling.component.html
// module chunks = main